export const supportedLanguages = ['pt', 'en', 'de', 'nl'] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<string, string> = {
    pt: 'Português',
    en: 'English',
    de: 'Deutsch',
    nl: 'Nederlands',
};
